import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';

import HeaderHamburger from './HeaderHamburger';
import Logo from './Logo';
import LogoutButton from './LogoutButton';
import Menu from './Menu';
import SelectIhreImmobilie from './SelectIhreImmobilie';

import { parseDate, parseTime } from '../../util/datetimeParser';

// STORE
import { setPageDialogOpenLoginForm, setResetFieldsLoginForm } from '../../reducers/loginForm';
import { setPageDialogOpenRegisterForm, setResetFieldsRegisterForm } from '../../reducers/registerForm';
import MenuButtonSwitcher from './MenuButtonSwitcher';

function Nav() {
  // Use specific selectors for more granular control over re-renders
  const mobileMenuOpen = useSelector((state) => state.app.mobileMenuOpen);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const firstName = useSelector((state) => state.user.userObject?.firstName || '');
  const lastName = useSelector((state) => state.user.userObject?.lastName || '');
  const lastLoggedIn = useSelector((state) => state.user.lastLoggedIn);

  const dispatch = useDispatch();

  // Memoize event handlers
  const handleOpenRegisterForm = useCallback(() => {
    dispatch(setResetFieldsRegisterForm());
    dispatch(setPageDialogOpenRegisterForm(true));
  }, [dispatch]);

  const handleOpenLoginForm = useCallback(() => {
    dispatch(setResetFieldsLoginForm());
    dispatch(setPageDialogOpenLoginForm(true));
  }, [dispatch]);

  // Memoize the mobile menu nav class
  const mobileNavClass = mobileMenuOpen ? 'is-visible header__nav--mobile' : 'header__nav--mobile';

  // Memoize the user greeting section
  const renderUserGreeting = () => {
    if (!isLoggedIn) {
      return (
        <div className="button-panel">
          <button className="button button--blue" onClick={handleOpenLoginForm}>
            Login
          </button>
          <button className="button button--gray-outline" onClick={handleOpenRegisterForm}>
            Registrieren
          </button>
        </div>
      );
    }

    return (
      <>
        <div className="mb-100rem">
          <span className="font-weight-600">
            Hallo,
            <br />
            {firstName} {lastName}!
          </span>

          {lastLoggedIn !== '' && (
            <>
              <br />
              <span className="font-90">
                Letzter Login: {parseDate(new Date())} {parseTime(new Date())}
              </span>
            </>
          )}
        </div>

        <MenuButtonSwitcher cssClasses={'mt-10 mb-20'} />
      </>
    );
  };

  return (
    <>
      {/* mobile menu */}
      <nav className={mobileNavClass}>
        <div className="header__nav--mobiletop">
          <Logo logoColor="blue" />
          <HeaderHamburger />
        </div>

        {renderUserGreeting()}

        <SelectIhreImmobilie />

        {/* Use regular Menu component to ensure it updates when menuId changes */}
        <Menu />
        <LogoutButton />

        <a href="https://www.sreal.at" target="_blank" className="text-link mt-200rem" rel="noreferrer">
          sREAL.at aufrufen
        </a>
      </nav>

      {/* desktop menu */}
      <Menu cssClasses="header__nav--desktop" />
    </>
  );
}

// Remove memo from Nav to allow it to update when dependencies change
export default Nav;
